import React from "react";

const ZoomControls: React.FC = () => {
  return null;
};

export default ZoomControls;
